<div class="card-primary">
  <h2 mat-dialog-title>{{ 'vouchers.dialog.title' | translate | capitalize }}</h2>

  <h3 style="font-weight: 500">
    {{ 'vouchers.dialog.buy-voucher' | translate | capitalize }}
  </h3>
  <p style="margin-bottom: 0px">
    {{ 'vouchers.dialog.purchase-price' | translate: { PRICE: voucherPrice } | capitalize }}
  </p>
  <p>
    {{
      'vouchers.dialog.valid-period'
        | translate
          : {
              START: schoolYearStart | date: 'dd-MM-yyyy',
              END: schoolYearEnd | date: 'dd-MM-yyyy',
            }
        | capitalize
    }}
  </p>
  <div class="actions-wrapper">
    <app-spinner-button [config]="buyBtnConfig" (onClick)="createPayment()"></app-spinner-button>
  </div>
  <div style="height: 75px"></div>
  <h3 style="font-weight: 500">
    {{ 'vouchers.dialog.enter-voucher' | translate | capitalize }}
  </h3>
  <p>
    {{ 'vouchers.dialog.enter-voucher-description' | translate | capitalize }}
  </p>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'vouchers.voucher-code' | translate | capitalize }}</mat-label>
    <input [formControl]="voucherFormControl" matInput />
    @if (voucherFormControl.hasError('required')) {
      <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }}</mat-error>
    }
  </mat-form-field>
  <div class="actions-wrapper">
    <app-spinner-button
      [config]="btnConfig"
      style="margin-top: 5px"
      (onClick)="save()"
      [disabled]="voucherFormControl.invalid"></app-spinner-button>
  </div>
</div>
